import { TFormErrors } from '../types';

/** Есть активные ошибки? */
export const hasErrors = (errors: TFormErrors): boolean => Object.values(errors).some(Boolean);
